import { CSSObject } from '@core-ui/react-stitch';

const getSelectOptionPositionStyle = (css?: CSSObject): CSSObject => {
  const isSafari = typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return isSafari ? { textIndent: css?.textIndent } : { textAlign: 'right' };
};

const getSeparateLabelStyles = (css?: CSSObject): CSSObject => {
  const textPosition = getSelectOptionPositionStyle(css);
  return {
    background: 'none',
    direction: 'rtl',
    fontWeight: 'normal',
    height: '1.8rem',
    padding: 0,
    ...textPosition,
  };
};

export default getSeparateLabelStyles;
